"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconType = exports.Icon = void 0;
var _react = require("react");
var _constants = require("../common/constants");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let IconType = exports.IconType = /*#__PURE__*/function (IconType) {
  IconType["OUTLINED"] = "OUTLINED";
  IconType["FILLED"] = "FILLED";
  return IconType;
}({});
const Icon = exports.Icon = /*#__PURE__*/(0, _react.forwardRef)(({
  size,
  className,
  component,
  style,
  children,
  type = IconType.FILLED,
  ...rest
}, ref) => /*#__PURE__*/(0, _react.createElement)(component, {
  className: (0, _classnames.default)(`frontino-icon frontino-icon--${size}`, className, type === IconType.OUTLINED && 'frontino-icon__outlined'),
  style,
  ref,
  ...rest
}, children));
Icon.frontinoName = 'FrontinoIcon';
Icon.defaultProps = {
  component: 'span',
  size: _constants.ComponentSize.MEDIUM
};